import { Form, Radio, Select } from 'antd';
import type { CargoKind } from '../../../policies/build-rate-line-input';
import { EmptyReturnField } from '../../../components/EmptyReturnField';
import type { RateLineCatalogues } from '../hooks/use-rate-line-catalogues';

const option = (item: { code: string; name: string }) => ({ value: item.code, label: item.name });

/**
 * What a line is priced against: a container (size and type) or a weight band, never both, so the other kind's fields are
 * not on screen at all — the same rule `rate-line-cargo.policy.ts` holds on the server. The empty-return answer is asked
 * only for a container, and is required: it is a recurring billing dispute, so it is never a silent default.
 */
export function CargoKeyFields({ catalogues }: { catalogues: RateLineCatalogues }) {
  const cargoKind = Form.useWatch<CargoKind>('cargoKind');

  return (
    <>
      <Form.Item name="cargoKind" label="Cargo">
        <Radio.Group
          options={[
            { value: 'container', label: 'Container' },
            { value: 'loose', label: 'Loose cargo' },
          ]}
        />
      </Form.Item>
      {cargoKind === 'container' && (
        <>
          <div className="grid grid-cols-2 gap-3">
            <Form.Item name="containerSizeCode" label="Container size" rules={[{ required: true, message: 'Choose a size' }]}>
              <Select options={catalogues.containerSizes.map(option)} />
            </Form.Item>
            <Form.Item name="containerTypeCode" label="Container type" rules={[{ required: true, message: 'Choose a type' }]}>
              <Select options={catalogues.containerTypes.map(option)} />
            </Form.Item>
          </div>
          <EmptyReturnField isRequired />
        </>
      )}
      {cargoKind === 'loose' && (
        <Form.Item name="weightBandCode" label="Weight band" rules={[{ required: true, message: 'Choose a weight band' }]}>
          <Select options={catalogues.weightBands.map(option)} />
        </Form.Item>
      )}
    </>
  );
}
